// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TerminationStatus from "../../../../app/termination/entity/TerminationStatus.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Start Time"
            },
            accessor: (function (record) {
                return {
                        TAG: /* Text */0,
                        _0: record.terminationStartTime
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "End Time"
              },
              accessor: (function (record) {
                  return {
                          TAG: /* Text */0,
                          _0: record.terminationEndTime
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Status"
                },
                accessor: (function (record) {
                    return {
                            TAG: /* Text */0,
                            _0: TerminationStatus.toString(record.terminationStatus)
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(terminationInfo) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: terminationInfo,
              children: (function (terminationInfo) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: getColumnsSchema(undefined),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(terminationInfo.driverTerminationHistory, undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getColumnsSchema ,
  getView ,
  
}
/* react Not a pure module */
